import Wrap, { GlobalStyle } from './styles';

import randomId from 'services/utils/generateRandomId';

import HooksProviders, { ModuleContext } from './hooks';

import HeadBar from '@map/components/HeadBar';
import ContactPage from '@map/components/HeadBar/components/MobileNavSideBar/views/ContactPage';
import LoginPage from '@map/components/HeadBar/components/MobileNavSideBar/views/LoginPage';
import MobileModulesSwitcher from '@map/components/HeadBar/components/MobileNavSideBar/views/MobileModulesSwitcher';
import SideBarNav from '@map/components/HeadBar/components/MobileNavSideBar/views/SideBarNav';
import MapArea from '@map/components/MapArea';
import MenuPanel from '@map/components/MenuPanel';
import MobileHeader from '@map/components/MobileHeader';
import ToolBar from '@map/components/ToolBar';
import AppContext from '@map/services/context';
// import CustomModalInstructionCard from 'components/CustomModalInstructionCard';
import WarningNotification from 'components/WarningNotification';
import * as React from 'react';
import { ThemeProvider } from 'styled-components';

const layoutElements = {
  'CPN-HEAD_BAR': 1,
  'CPN-TOOL_BAR': 3,
  'CPN-MAP_AREA': 4,
  'CPN-MENU_PANEL': 2,
};
export class MapView extends React.Component {
  
  /**
   * State de map que serve como referência e context
   * global de toda a aplicação de mapa público
   */
  // TODO Colocar context em arquivo separado fornecendo provider, boa prática
  state = {
    /**
     * * CONFIGURAÇÕES DE TEMA E RECURSOS DE UI
     */
    themeVariables: {
      primaryColor: '#3c71dd',
      primaryColorDark: '#1f2d4d',
      sideBarNavWidth: 80,
      icons: window.innerWidth > 768 ? '#BEC7DC' : 'white', // #1F2D4D
    },

    // Recebendo um objeto com novos atributos, seta eles no tema principal
    setThemeVariables: (variables) => {
      let themeVariables = { ...this.state.themeVariables };
      Object.entries(variables).forEach((newItem) => {
        themeVariables[newItem[0]] = newItem[1];
      });
      this.setState({ themeVariables });
    },
    // Desabilita todos os recursos de opções e menus, útil para visualizar menu de configurações de ferramentas, por exemplo
    hidedInterface: false,
    setHidedInterface: (hidedInterface) => this.setState({ hidedInterface }),

    /**
     * Bottom Panel
     * Abre na area do mapa
     */
    bottomPanelIsOpen: false,
    bottomPanelTitle: '',
    bottomPanelContent: null,
    setBottomPanelIsOpen: (isOpen, title = '', content = null) => {
      const bottomPanelId = randomId();
      this.setState(
        {
          bottomPanelIsOpen: isOpen,
          bottomPanelContent:
            isOpen && !this.state.bottomPanelIsOpen ? content : null,
          bottomPanelTitle: isOpen ? title : '',
          bottomPanelId,
        },
        () =>
          isOpen &&
          this.state.bottomPanelIsOpen &&
          this.setState({ bottomPanelContent: content })
      );
      return bottomPanelId;
    },

    /**
     * * SIDE BAR
     * O side bar se tornou um pouco mais complexo quando no
     * mesmo componente foi necessário incrementar histórico
     * para fazer retornos de páginas, ou seja, em algum lugar
     * deve ter armazenado por onde os link passaram para que,
     * possa-se retornar
     */
    activeRoute: null,
    sideBarIsOpened: false,
    SideBarComponent: null,
    sideBarTitle: '',
    sideBarHistory: [],
    backSideBarHistory: () => {
      // verifica se existe algum item para voltar
      if (this.state.sideBarHistory.length > 1) {
        let history = JSON.parse(JSON.stringify(this.state.sideBarHistory));
        history.pop();
        let newHistory = [...history];
        let last = history.pop();
        this.setState(
          {
            sideBarHistory: newHistory,
          },
          () => {
            this.state.openSideBar(last, false);
          }
        );
      } else {
        this.state.closeSideBar();
      }
      // Caso não exista apaga e fecha tudo
    },
    sideBarRoutes: {
      login: {
        width: 100,
        title: 'Login',
        Component: <LoginPage />,
      },
      'select-modules': {
        title: 'Módulos',
        Component: <MobileModulesSwitcher />,
      },
      'main-nav': {
        title: '',
        Component: <SideBarNav />,
      },
      contact: {
        title: 'Contato',
        Component: <ContactPage />,
      },
    },
    openSideBar: (route, pushHistory = true) => {
      this.setState(
        {
          sideBarHistory: pushHistory
            ? [...this.state.sideBarHistory, route]
            : [...this.state.sideBarHistory],
          sideBarIsOpened: true,
          SideBarComponent: this.state.sideBarRoutes[route].Component,
          sideBarTitle: this.state.sideBarRoutes[route].title,
        },
        () => {
          this.state.setThemeVariables({
            sideBarNavWidth: this.state.sideBarRoutes[route].width || 80,
          });
        }
      );
    },
    closeSideBar: () => {
      this.setState(
        {
          sideBarHistory: [],
          sideBarIsOpened: false,
        },
        () => {
          this.state.setThemeVariables({ sideBarNavWidth: 80 });
        }
      );
    },
    toogleSideBar: (route) => {
      if (this.state.sideBarIsOpened) {
        this.state.closeSideBar();
      } else {
        this.state.openSideBar(route);
      }
    },
    /**
     * * CATÁLOGO DE CAMADAS
     */
    layersCatalogIsOpened: false,
    genericSetContextProp: (prop, value) => this.setState({ [prop]: value }),

    //Dialog Mobile
    dialogMobileOpen: false,
    dialogMobileTitle: '',
    dialogMobileContent: null,
    dialogMobileOnClose: null,
    setDialogMobileOpen: (
      open = false,
      title = '',
      content = null,
      onClose = null
    ) =>
      this.setState({
        dialogMobileOpen: open,
        dialogMobileTitle: title,
        dialogMobileContent: content,
        dialogMobileOnClose: onClose,
      }),

    //Cursor Mobile
    mobileCursor: null,
    setMobileCursor: (cursorIcon = null) =>
      this.setState({ mobileCursor: cursorIcon }),
  };

  // shouldComponentUpdate(nextProps) {
  //   return true;
  // }

  render() {
    const { themeVariables } = this.state;
    
    return (
      <ThemeProvider theme={themeVariables}>
        <HooksProviders>
          <AppContext.Provider value={this.state}>
            <ModuleContext.Consumer>
              {({ activeModule }) => (
                <Wrap
                  sideBarIsOpened={this.state.sideBarIsOpened}
                  toolBar={activeModule?.elemento?.includes(
                    layoutElements['CPN-TOOL_BAR']
                  )}
                >
                  <div className="top_shadow" />

                  <GlobalStyle />
                  <HeadBar />
                  {activeModule?.elemento?.includes(
                    layoutElements['CPN-TOOL_BAR']
                  ) && <ToolBar />}
                  <div className="page_wrap">
                    {activeModule?.elemento?.includes(
                      layoutElements['CPN-MENU_PANEL']
                    ) && (
                      <MenuPanel
                        toolBar={activeModule?.elemento?.includes(
                          layoutElements['CPN-TOOL_BAR']
                        )}
                      />
                    )}
                    <MapArea />
                  </div>
                  {/* <pre>{JSON.stringify(this.state.modules, null, 2)}</pre> */}
                  <WarningNotification />
                  {/* <CustomModalInstructionCard/> */}
                  <div className="bottom_shadow"  />
                  {this.state.dialogMobileOpen && (
                    <div className="mobile-dialog">
                      <MobileHeader
                        title={this.state.dialogMobileTitle}
                        onClick={(e) => {
                          this.state.setDialogMobileOpen();
                          this.state.dialogMobileOnClose &&
                            this.state.dialogMobileOnClose();
                        }}
                      />
                      <div className="mobile-dialog-content">
                        {this.state.dialogMobileContent}
                      </div>
                    </div>
                  )}
                  {this.state.mobileCursor && (
                    <div className="mobile-cursor">
                      {this.state.mobileCursor}
                    </div>
                  )}
                </Wrap>
              )}
            </ModuleContext.Consumer>
          </AppContext.Provider>
        </HooksProviders>
      </ThemeProvider>
    );
  }
}

export default MapView;
